/* @flow */

export const LOGO = {
    PP:         ('pp' : 'pp'),
    PAYPAL:     ('paypal' : 'paypal'),
    VENMO:      ('venmo' : 'venmo'),
    CREDIT:     ('credit' : 'credit'),
    IDEAL:      ('ideal' : 'ideal'),
    ELV:        ('elv' : 'elv'),
    SEPA:       ('sepa' : 'sepa'),
    BANCONTACT: ('bancontact' : 'bancontact'),
    GIROPAY:    ('giropay' : 'giropay'),
    SOFORT:     ('sofort' : 'sofort'),
    EPS:        ('eps' : 'eps'),
    MYBANK:     ('mybank' : 'mybank'),
    P24:        ('p24' : 'p24'),
    ZIMPLER:    ('zimpler' : 'zimpler'),
    WECHATPAY:  ('wechatpay' : 'wechatpay')
};

export const LOGO_COLOR = {
    BLUE:    ('blue' : 'blue'),
    BLACK:   ('black' : 'black'),
    WHITE:   ('white' : 'white'),
    DEFAULT: ('default' : 'default')
};

export const LOGO_CLASS = {
    LOGO:       ('paypal-logo' : 'paypal-logo'),
    CARD:       ('paypal-logo-card' : 'paypal-logo-card'),
    LOGO_COLOR: ('paypal-logo-color' : 'paypal-logo-color')
};
